/* BANNERS */
export const GET_BANNERS = "GET_BANNERS"
export const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS"
export const GET_BANNERS_FAIL = "GET_BANNERS_FAIL"
